import type {
  ICampaignTargetCustom,
  ICustomCampaignTargetRule,
} from "@shared/common/custom-target-condition/types";

export const shopifyUserLogin: ICustomCampaignTargetRule = {
  key: "SHOPIFY_USER_LOGIN",

  checkValidRule({ siteType }) {
    return siteType === "SHOPIFY";
  },

  getDefaultValue() {
    return {
      type: "CUSTOM",
      key: "SHOPIFY_USER_LOGIN",
      value: "EVERYONE",
    };
  },

  getShortLabel(target: ICampaignTargetCustom) {
    switch (target.value) {
      case "EVERYONE":
        return null;
      case "NO_LOGIN":
        return "비로그인 사용자";
      case "LOGIN":
        return "로그인 사용자";
      default:
        return null;
    }
  },

  checkPage(condition, { html }) {
    if (condition.key !== "SHOPIFY_USER_LOGIN") {
      return false;
    }

    if (condition.value === "EVERYONE") {
      return true;
    }

    /**
     * 테스트용 샘플
     *
     * 미로그인
     *  window.ShopifyAnalytics.lib.page(null,{"pageType":"home"});
     *
     * 로그인
     *  window.ShopifyAnalytics.lib.page(null,{"customerId":6077025255576});
     */

    const isLogin =
      /window\.ShopifyAnalytics\.lib\.page.+?"customerId":([0-9]+)/.test(
        html.innerHTML
      );

    switch (condition.value) {
      case "NO_LOGIN":
        return !isLogin;
      case "LOGIN":
        return isLogin;
    }
  },
};

export default shopifyUserLogin;
